import './App.css';
import "./App.scss";
// import React, { useState, useEffect } from "react";
import { BrowserRouter as Router} from "react-router-dom";
import { ReactAuthWrapper } from '@carrier-sce-sharedpackages/reactauthwrapper';
import { appConfig } from './appConfig';
import Main from "./screens/Main";
import { Provider,connect } from "react-redux";
import store from "./reducers";
import { getData } from "./services/APIServiceInterface";
import { useEffect, useState } from 'react';
import * as appAction from "./actions/appAction";
import Loading from "./components/Loading/Loading";

var CONTROLS_DATA = require("./screens/ControlsData.json");

export const getSecurityLevel = async (email) => {
  const response = await getData(`/user/getSecurityLevel?userEmail=${email}`);
  return response;
};

export const getLoggedInUserId = async(email) => {
  const response = await getData(`user/getAssociatedId?userEmail=${email}`);
  return response;
}

// const App = ({permissions,getLoggedUserRoleAction,getLoggedUserIdAction,userRole,userId}) => {
const App = ({permissions}) => {
  const [userPermission, setUserPermission] = useState(null);
  const [loading, setLoading] = useState(false);


  const callback =async (permissions) => {
    // await  getLoggedUserRoleAction(permissions.emailAddress);
    // await getLoggedUserIdAction(permissions.emailAddress)
    //setUserRole(role);

    // try{
    //   setLoading(true);
    //   const role = await getSecurityLevel(permissions?.emailAddress);
    //   const loggedInUserId = await getLoggedInUserId(permissions?.emailAddress);
    //   setUserPermission({
    //     userRole:role.data,
    //     userId:loggedInUserId.data
    //   });
    //   setLoading(false);
    // }
    // catch(error){
    //   console.log('got error in app',error);
    //   setLoading(false);
    // }
  }

  useEffect(() => {
    if(permissions?.emailAddress){
      callback(permissions);
    }
  },[permissions])

  if (window.top !== window.self) {
    window.top.location = window.self.location;
  }

  // useEffect(() => {
  //   setLoggedUserRole(userRole);
  // },[userRole])
  
  return (

    <div className="App">
      {/* <Loading open={loading} /> */}
      <Router>
        <Provider store={store}>
        <ReactAuthWrapper appConfig={appConfig} getPermissions={callback}>
          <Main permissions={permissions} />
        </ReactAuthWrapper>
        </Provider>
      </Router>
    </div>
  );
}

// const mapStateToProps = (state) =>({
//   userRole: state.loggedInUserInfo?.userRole || null,
//   userId: state.loggedInUserInfo.userId || null
// })

// const mapDispatchToProps = (dispatch) =>({
//   getLoggedUserRoleAction: (email) => dispatch(appAction.getLoggedUserRoleAction(email)),
//   getLoggedUserIdAction: (email) => dispatch(appAction.getLoggedUserIdAction(email))
// })

// const ConnectedApp = connect(mapStateToProps,mapDispatchToProps)(App);

// const WrappedApp = (props) => {
//   <Provider store={store}>
//     <ConnectedApp {...props} />
//   </Provider>
// }

export default App;
